import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { StyledCallToAction } from '../../../sharedComponents';

export type StyledBookButtonProps = {
  label: string;
  disabled: boolean;
  url: string;
};

export const StyledBookButton = ({
  label,
  disabled,
  url,
}: StyledBookButtonProps) => {
  const themeConfig = useContext(ThemeContext);
  const dStyles = themeConfig.module.dStyles.elements.booking;
  const vStyles = themeConfig.module.vStyles.elements.booking;
  const {
    elements: {
      callToAction: {
        settings: { mode: styledMode, look: styledLook, size },
      },
    },
  } = vStyles;
  const ctaConfig = {
    openInNewTabEnabled: false,
    shown: true,
    type: 'CUSTOM',
  };
  const btnLook = disabled ? 'disabled' : styledLook;
  const btnMode = disabled ? 'none' : styledMode;

  return (
    <StyledCallToAction
      label={label}
      size={size}
      look={btnLook}
      mode={btnMode}
      disabled={disabled}
      to={url}
      displayStyles={dStyles}
      visualStyles={vStyles}
      ctaConfig={ctaConfig}
    />
  );
};
